export default __webpack_public_path__ + "static/media/ai_face_detectionActive.c65da4ec.svg";